import script from './SdsTooltip.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sds-tooltip-base",class:("sds-tooltip-base--" + _vm.variant)},[_c('div',{staticClass:"tooltip-pointer",class:("tooltip-pointer--" + _vm.pointer)}),_vm._v(" "),_c('div',{staticClass:"text-content"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"hotkey-instructions"},[_vm._t("hotkey")],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-d28e39cc_0", { source: ".sds-tooltip-base[data-v-d28e39cc]{position:relative;display:inline-flex;flex-direction:column;align-items:flex-start;max-width:176px;padding:4px 8px;border-radius:var(--radius-sm);font-family:var(--system-label-small-family);font-size:var(--system-label-small-size);line-height:var(--system-label-small-line-height);letter-spacing:var(--system-label-small-letter-spacing)}.sds-tooltip-base--primary[data-v-d28e39cc]{background-color:var(--component-tooltip-default-bg);color:var(--component-tooltip-default-text)}.sds-tooltip-base--secondary[data-v-d28e39cc]{background-color:var(--component-tooltip-alternative-bg);color:var(--component-tooltip-alternative-text)}.sds-tooltip-base .hotkey-instructions[data-v-d28e39cc]{opacity:.72}.sds-tooltip-base .tooltip-pointer[data-v-d28e39cc]{display:block;background-color:inherit;width:8px;height:8px;border:inherit;position:absolute;clip-path:polygon(0 0,100% 100%,0 100%);border-radius:0 0 0 .25em}.sds-tooltip-base .tooltip-pointer--down[data-v-d28e39cc],.sds-tooltip-base .tooltip-pointer--up[data-v-d28e39cc]{left:calc(50% - 4px)}.sds-tooltip-base .tooltip-pointer--left[data-v-d28e39cc],.sds-tooltip-base .tooltip-pointer--right[data-v-d28e39cc]{top:calc(50% - 4px)}.sds-tooltip-base .tooltip-pointer--up[data-v-d28e39cc]{bottom:calc(100% - 4px);transform:rotate(135deg)}.sds-tooltip-base .tooltip-pointer--down[data-v-d28e39cc]{top:calc(100% - 4px);transform:rotate(-45deg)}.sds-tooltip-base .tooltip-pointer--left[data-v-d28e39cc]{right:calc(100% - 4px);transform:rotate(45deg)}.sds-tooltip-base .tooltip-pointer--right[data-v-d28e39cc]{left:calc(100% - 4px);transform:rotate(-135deg)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-d28e39cc";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
